export * from './baThemeRun.directive';



// WEBPACK FOOTER //
// /app/src/app/theme/directives/baThemeRun/index.ts